<!-- 添加附件 -->
<template>
  <div class="affix-section">
    <a-upload
      :file-list="fileList"
      :multiple="true"
      :custom-request="_uploadFile"
      :disabled="loading"
      :remove="handleRemove"
    >
      <a-button>
        <a-icon :type="loading ? 'loading' : 'upload'" />
        添加附件
      </a-button>
    </a-upload>
  </div>
</template>
<script>
import { uploadFile, deleteFile } from '../api'

export default {
  data() {
    return {
      loading: false,
      fileList: [],
      attachmentIds: [],
    }
  },
  props: ['suffixs', 'maxSize'],
  mounted() {},
  methods: {
    validateSuffix(file) {
      const suffixs = this.suffixs
      if (!suffixs) {
        return true
      }
      const suffix = file.name
        .toLowerCase()
        .split('.')
        .splice(-1)
        .join('')
      if (suffixs.includes(suffix)) {
        return true
      }
      this.$message.warning(`仅支持${suffixs.join(', ')}格式`)
      return false
    },
    validateSize(file) {
      const maxSize = this.maxSize
      if (!maxSize) {
        return true
      }
      const size = file.size
      if (size < maxSize * 1024 * 1024) {
        return true
      }
      this.$message.warning(`上传文件大小不能超过 ${maxSize}MB`)
      return false
    },
    validate(file) {
      const validateMethods = ['validateSuffix', 'validateSize']
      return validateMethods.every(method => {
        return this[method](file)
      })
    },

    async _uploadFile(file) {
      this.loading = true
      const crtFile = file.file
      const valid = this.validate(crtFile)
      if (!valid) {
        this.loading = false
        return
      }
      const formData = new FormData()
      formData.append('file', crtFile)
      try {
        const { data } = await uploadFile(formData)
        this.fileList.push(crtFile)
        this.attachmentIds.push(data)
        this.loading = false
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    handleRemove(file) {
      this.$confirm({
        title: '提示',
        content: `确定移除 ${file.name} ?`,
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          const index = this.fileList.indexOf(file)
          const newFileList = this.fileList.slice()
          try {
            await deleteFile(this.attachmentIds[index])
            newFileList.splice(index, 1)
            this.attachmentIds.splice(index, 1)
            this.fileList = newFileList
          } catch (error) {
            console.error(error)
          }
        },
      })
    },
    // 暴露给父组件的方法
    getAttachmentIds() {
      return this.attachmentIds
    },
  },
}
</script>

<style lang="less" scoped></style>
